/* eslint-disable  react/display-name*/
import {
  Button,
  CircularProgress,
  IconButton,
  Tooltip,
  Typography,
  Grid,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";

import PDialog from "../../components/pos/PDialog";
import db from "../../db/db";
import MUIDataTable from "mui-datatables";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../utils/API";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { AgentUtils } from "../../utils/AgentUtils";

const theme = createTheme({
  components: {
    MUIDataTableBodyCell: {
      styleOverrides: {
        root: {
          padding: 8,
          color: "#555555",
        },
      },
    },
    MUIDataTableBodyRow: {
      styleOverrides: {
        root: {
          "&:nth-child(odd)": {
            backgroundColor: "#fafafa",
          },
        },
      },
    },
  },
});

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export default function UnHoldList(props) {
  const { t } = useTranslation();
  const translate = t;
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [rowIndex, setRowIndex] = useState(0);
  const [dataTableHeight, setDataTableHeight] = useState(0);

  useEffect(() => {
    loadData();
    function handleResize() {
      setDataTableHeight(getWindowDimensions().height - 300);
    }
    setDataTableHeight(getWindowDimensions().height - 300);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function getApi() {
    if (props.saleType === "SALE") {
      return "sale_hold";
    }
    if (props.saleType === "SALE_RETURN") {
      return "sale_return_hold";
    }
    if (props.saleType === "SERVICE") {
      return "service_hold";
    }
    if (props.saleType === "SALE_ORDER") {
      return "sale_order_hold";
    }
    return "";
  }

  async function onUnHoldClicked(row) {
    //props.unHoldSale(row.tableData[row.rowIndex]);
    console.log(row.tableData[row.rowIndex]);

    let { data } = await API.get(
      "/api/v1/" + getApi() + "/" + row.tableData[row.rowIndex].id
    );

    await API.delete(
      "/api/v1/" + getApi() + "/" + row.tableData[row.rowIndex].id
    );

    if (props.saleType === "SERVICE") {
      props.handleSelectService(data, null);
    } else {
      props.handleSelectSale(data, null);
    }
    props.setShowUnHoldWindow(false);
  }

  function onCloseWindow() {
    props.setShowUnHoldWindow(false);
  }

  async function loadData() {
    let sort = '[{id:"date",sortOrder:"DESC"}]';
    loadByRest(0, 6, sort, "[]");
    //loaadByDB();
  }
  async function loadByRest(curPage, pageSize, sort, filter) {
    setIsLoading(true);
    const status = "HOLD";
    const result = await await API.get(
      "/api/v1/hold/list?range=" +
        encodeURIComponent(
          "[" + curPage * pageSize + "," + ((curPage + 1) * pageSize - 1) + "]"
        ) +
        "&filter=" +
        encodeURIComponent(filter) +
        "&sort=" +
        encodeURIComponent(sort) +
        "&searchType=" +
        encodeURIComponent(props.saleType)
    );

    var arr = result.data.contentRange.split("/");
    const opt = { ...option };
    opt.count = parseInt(arr[2]);
    setOption(opt);

    setData(result.data.data);

    /*var arr = result.headers["content-range"].split("/");
    const opt = { ...option };
    opt.count = parseInt(arr[2]);
    setOption(opt);
    setData(result.data);
    setRowIndex(0);
    option.rowsSelected = [0];
    setOption(options);*/
    setIsLoading(false);
  }

  async function loaadByDB() {
    db.hold.toArray(function (data) {
      setData(data);
    });
  }

  async function onTableChange(tableState) {
    console.log(tableState.sortOrder);
    let sort = '[{id:"date",sortOrder:"DESC"}]';
    let searchStr = [];
    if (tableState.searchText) {
      searchStr.push({
        id: "invoiceNo",
        value: "",
        regExp: ".*" + tableState.searchText + ".*",
        matchType: "BROAD_MATCH",
        conditionType: "or",
        operatorType: "",
        fieldValueType: "string",
      });
      searchStr.push({
        id: "holdNote",
        value: "",
        regExp: ".*" + tableState.searchText + ".*",
        matchType: "BROAD_MATCH",
        operatorType: "",
        conditionType: "or",
        fieldValueType: "string",
      });
      searchStr.push({
        id: "customerName",
        value: "",
        regExp: ".*" + tableState.searchText + ".*",
        matchType: "BROAD_MATCH",
        operatorType: "",
        conditionType: "or",
        fieldValueType: "string",
      });
    }
    loadByRest(
      tableState.page,
      tableState.rowsPerPage,
      sort,
      JSON.stringify(searchStr)
    );
  }

  function updateRowIndex(e) {
    console.log("row index: " + rowIndex);
    var currRow = rowIndex;

    if (e.keyCode === 13) {
      console.log("keyEvent called..." + JSON.stringify(data.length));
      props.unHoldSale(data[rowIndex]);
      props.setShowUnHoldWindow(false);
    }
    if (e.keyCode === 38) {
      if (currRow > 0) currRow = currRow - 1;
      options.rowsSelected = [currRow];
      setOption(options);
      setRowIndex(currRow);
      console.log("decremented: " + rowIndex);
    }
    if (e.keyCode === 40) {
      if (currRow < data.length - 1) currRow = currRow + 1;
      options.rowsSelected = [currRow];
      setOption(options);
      setRowIndex(currRow);
      console.log("incremented: " + rowIndex);
    }
  }

  const options = {
    serverSide: true,
    filterType: "dropdown",
    rowHover: true,
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    tableBodyMaxHeight: "100%",
    tableBodyHeight: dataTableHeight,
    expandableRowsHeader: false,
    customToolbarSelect: () => {},
    fixedHeader: true,
    selectableRows: "single",
    print: false,
    download: false,
    filter: false,
    viewColumns: false,
    tableBodyHeight: "400px",
    rowsPerPage: 6,
    rowsPerPageOptions: [6, 15, 50, 100],
    onTableChange: (action, tableState) => {
      // a developer could react to change on an action basis or
      // examine the state as a whole and do whatever they wan

      switch (action) {
        case "changePage":
          onTableChange(tableState);
          break;
        case "sort":
          onTableChange(tableState);
          break;
        case "changeRowsPerPage":
          onTableChange(tableState);
          break;
        case "search":
          onTableChange(tableState);
          break;
        default:
        //console.log("action not handled." + action);
      }
    },
    customToolbar: () => {
      return (
        <React.Fragment>
          <Tooltip title={translate("Refresh Data")}>
            <IconButton
              size="small"
              color="primary"
              onClick={saleHistoryRefresh}
            >
              <RefreshIcon />
            </IconButton>
          </Tooltip>
        </React.Fragment>
      );
    },
  };

  const [option, setOption] = useState(options);

  function formatDate(date) {
    let formatted =
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1 <= 9
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) +
      "-" +
      (date.getDate() <= 9 ? "0" + date.getDate() : date.getDate());
    return formatted;
  }

  const columns = [
    {
      name: "invoiceNo",
      label: translate("Hold No."),
      options: {
        filter: false,
        sort: true,
      },
    },

    {
      name: "totalAmount",
      label: translate("Total Amount"),
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "date",
      label: translate("Date"),
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return formatDate(new Date(value));
        },
      },
    },
    {
      name: "customerName",
      label: translate("Customer"),
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "holdNote",
      label: translate("Hold note"),
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "action",
      label: translate("Actions"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        setCellHeaderProps: () => ({ align: "right" }),
        setCellProps: () => ({ align: "right" }),
        customBodyRender: (value, tableMeta, updateValue) => (
          <Button
            onClick={() => onUnHoldClicked(tableMeta, updateValue, value)}
            color="secondary"
            style={{
              margin: 0,
              padding: 0,
              height: 17,
              width: 27,
              alignText: "right",
            }}
          >
            Un Hold
          </Button>
        ),
      },
    },
  ];

  function saleHistoryRefresh() {
    loadData();
  }

  var biRef = {};

  const content = (
    <ThemeProvider theme={theme}>
      <MUIDataTable
        title={
          <Typography variant="h6">
            {translate(" Hold List")}
            {isLoading && (
              <CircularProgress
                size={24}
                style={{ marginLeft: 15, position: "relative", top: 4 }}
              />
            )}
          </Typography>
        }
        data={data}
        columns={columns}
        options={option}
      />
    </ThemeProvider>
  );
  return (
    <div>
      <PDialog
        content={content}
        title={"Un Hold"}
        maxWidth={"md"}
        fullWidth={true}
        open={true}
        onCloseWindow={onCloseWindow}
        onKeyDown={updateRowIndex}
        hideSave={true}
      ></PDialog>
    </div>
  );
}
